import script from "./HeroPatchNotesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroPatchNotesPage.vue?vue&type=script&setup=true&lang=js"

import "./HeroPatchNotesPage.vue?vue&type=style&index=0&id=e772d7b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e772d7b4"]])

export default __exports__